import { render, staticRenderFns } from "./gas.vue?vue&type=template&id=4ed6d8f8&scoped=true"
import script from "./gas.vue?vue&type=script&lang=js"
export * from "./gas.vue?vue&type=script&lang=js"
import style0 from "./gas.vue?vue&type=style&index=0&id=4ed6d8f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6d8f8",
  null
  
)

export default component.exports